module.exports = __webpack_public_path__ + "24e65205f3f0d25c83cec2b78d2b83c8.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/4.svg
// module id = 624
// module chunks = 0